// Phase 85.A.158 — Smart wrapper: fetch setting `rating_verification_mode`,
// render `SelfRatingDeclareModal` (default) hoặc `SelfRatingVerificationModal`
// (legacy OCR) tùy admin config.
import { useEffect, useState } from "react";
import { api } from "../../../lib/api";
import SelfRatingDeclareModal from "./SelfRatingDeclareModal";
import SelfRatingVerificationModal from "./SelfRatingVerificationModal";

// Cache mode trong window để không fetch lại nhiều lần.
const _CACHE_KEY = "__pickleagueRvMode";

async function fetchMode() {
  if (typeof window !== "undefined" && window[_CACHE_KEY]) return window[_CACHE_KEY];
  try {
    const r = await api.get("/athlete/rating-verification/mode");
    const m = r?.data?.mode || "self_declare";
    if (typeof window !== "undefined") window[_CACHE_KEY] = m;
    return m;
  } catch {
    return "self_declare";
  }
}

export default function SelfRatingVerificationModalSmart({ open, onClose, onSubmitted }) {
  const [mode, setMode] = useState(null);
  useEffect(() => {
    if (!open) return;
    fetchMode().then(setMode);
  }, [open]);

  if (!open) return null;
  if (mode === null) return null; // loading — không flash UI

  if (mode === "ocr_screenshot") {
    return <SelfRatingVerificationModal open={open} onClose={onClose} onSubmitted={onSubmitted} />;
  }
  return <SelfRatingDeclareModal open={open} onClose={onClose} onSubmitted={onSubmitted} />;
}

// Invalidate cache (gọi sau khi admin đổi mode).
export function invalidateRvModeCache() {
  if (typeof window !== "undefined") delete window[_CACHE_KEY];
}
